import { MediaCarousel } from './mediaCarousel';

export default MediaCarousel;
